module.exports = __webpack_public_path__ + "images/185_1024.jpg";